import filter from "lodash/filter";
import map from "lodash/map";
import intersection from "lodash/intersection";
import getGraphNodeSources from "./nodeOrEdgeSourceDataHandling/getGraphNodeSources";
import highlightNodes from "./highlightNodes";
import navigateToNodes from "./navigateToNodes";
export default (graphComponentRef, sourceTaskIds, onClearSourceTaskIdsToHighlight, documentId) => {
    var _a;
    if (!((_a = graphComponentRef.current) === null || _a === void 0 ? void 0 : _a.graph) || !documentId)
        return;
    const nodesToHighlight = filter(graphComponentRef.current.graph.nodes.toArray(), n => {
        const sources = getGraphNodeSources(n);
        if (intersection(map(sources, "SourceTaskId"), sourceTaskIds).length > 0) {
            return true;
        }
        return false;
    });
    highlightNodes(graphComponentRef, nodesToHighlight);
    navigateToNodes(graphComponentRef, nodesToHighlight);
    onClearSourceTaskIdsToHighlight(documentId);
};
